module.exports = __webpack_public_path__ + "static/media/Screenshot8.ce124c43.png";